import { FormFiled, FormFieldTypes } from '../../../models';

export function getConditionOperator(formFiled: FormFiled): string[] {
  switch (formFiled.type) {
    case FormFieldTypes.number: {
      return [
        'greater than',
        'greater than or equal',
        'less than',
        'less than or equal',
        'equal',
        'not equal',
        'empty',
        'not empty',
      ];
    }
    case FormFieldTypes.date: {
      return [
        'greater than',
        'greater than or equal',
        'less than',
        'less than or equal',
        'equal',
        'not equal',
        'between',
        'empty',
        'not empty',
      ];
    }

    default: {
      return [
        'equal',
        'not equal',
        'contain',
        'not contain',
        'empty',
        'not empty',
      ];
    }
  }
}

export const convertTitleCaseToConditionsEnum = (
  titleCaseCondition: string
) => {
  return titleCaseCondition
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};
